export default __webpack_public_path__ + "static/media/pg-white.fa7d7077.svg";